const storeName = 'comparehub_loanscanada';

const setCookie = (value) => {
    let name = storeName;
    let expirationDays = 30;

    let d = new Date();
    d.setTime(d.getTime() + (expirationDays*24*60*60*1000));
    let expires = "expires="+ d.toUTCString();
    document.cookie = name + "=" + value + ";" + expires + ";path=/";
}

const setLocal = (value) => {
    let name = storeName;
    localStorage[name] = value;
}

const setSession = (value) => {
    let name = storeName;
    sessionStorage.setItem(name, value);
}

const getSafeApplicationData = (app) => {

    let removeTheseKeysFromAppObject = [
        'urlParameters',
        'password',
        'password_confirmation'
    ];

    let saveableData = {};
    Object.entries(app).forEach(entry => {
        if(!removeTheseKeysFromAppObject.includes(entry[0])) {
            saveableData[entry[0]] = entry[1];
        }
    });
    return JSON.stringify(saveableData);
}

const setLocalStorage = (app) => {
    let appData = getSafeApplicationData(app);
    // setCookie(appData);
    setLocal(appData);
    setSession(appData);
}

const getLocalStorage = (item = storeName) => {
    return localStorage.getItem(item) ?
        JSON.parse(localStorage.getItem(item)) :
        null;
}

const getUrlParameters = () => {
    let queryString = window.location.search;
    let urlParams = new URLSearchParams(queryString);
    let entries = urlParams.entries();

    let appParameters = [
        'requested_amount',
        'first_name',
        'last_name',
        'email',
        'affiliate_id',
        'product_name',
        'flinks_demo',
        'flinks_skip',
        // 'sms_skip',
        // refresh app - this helps to hide message 'Continue with your application' when is a prepop lead
        'ra',
        'token'
    ];

    let trackingParameters = [
        'utm_source',
        'utm_medium',
        'utm_campaign',
        'utm_content',
        'utm_term',
        'cmi_click_id',
        // => google click ids
        'gclid',
        // 'gbraid',
        // 'wbraid',
        // google click ids <==
        'fbclid',
        'ttclid',
        'msclkid',
        // affiliate
        'affiliate_id',
        'affiliate_sub1',
        'affiliate_sub2',
        'affiliate_sub3',
        'affiliate_sub4',
        'affiliate_sub5',
    ];

    let prepopFields = [
        'car_request_type',
        'new_asset_name',
        // from pre-pop
        // 'product_purpose', 'requested_amount', 'first_name', 'last_name', 'email', 'dob', 'city',
        // 'state', 'postal_code', 'cell_phone', 'work_phone', 'address', 'own_home', 'address_length_months',
        // 'rent_mortgage_payment', 'property_value', 'property_mortgage', 'income_type', 'employer', 'job_title',
        // 'monthly_income', 'employed_months', 'direct_deposit', 'pay_frequency', 'pay_date1',
        // 'in_dmp', 'in_bankruptcy', 'in_consumer_proposal', 'cc_debt_amount', 'unsecured_debt_amount',
        // 'lang', 'canadian_status', 'aff_utm_source', 'aff_utm_medium', "aff_utm_campaign", 'aff_utm_content', 'aff_utm_term',
        // 'affiliate_sub1', 'affiliate_sub2', 'affiliate_sub3', 'affiliate_sub4', 'affiliate_sub5'
    ];

    let forceOnlyDigits = [
        'requested_amount',
        'affiliate_id',
        // prepop
        // personal
        'cell_phone',
        'address_length_months',
        'rent_mortgage_payment',
        'property_value',
        'property_mortgage',
        // work
        'monthly_income',
        'employed_months',
        'work_phone',
        // debt
        'cc_debt_amount',
        'unsecured_debt_amount'
    ];

    let mapFieldsFromCmi = {
        'cell_phone': 'phone_number',
        'work_phone': 'phone_number_work',
    };

    const safeUrlParameters = [...appParameters,...trackingParameters, ...prepopFields];

    var urlParameters = {};
    for(const entry of entries) {
        var key = entry[0];
        var value = entry[1];

        if(safeUrlParameters.includes(key)) {
            urlParameters[mapFieldsFromCmi[key] ?? key] = forceOnlyDigits.includes(key) ? value.replace(/\D/g,'') : value;
        }
    }

    // if gclid is not set lets try with the 2 other possible names
    // let googleClickValue = urlParameters['gclid'] || urlParameters['gbraid'] || urlParameters['wbraid'];
    // if (googleClickValue) {
    //     urlParameters['gclid'] = googleClickValue;
    // }
    // remove the other 2 google click ids
    // ['gbraid', 'wbraid'].forEach(key => delete urlParameters[key]);

    return urlParameters;
}

export { setLocalStorage, getLocalStorage, getUrlParameters }
